const domReady = onReady => {
    window.requestAnimationFrame(function check() {
        document.body ? onReady() : window.requestAnimationFrame(check);
    });
};
export default domReady;
//# sourceMappingURL=dom-ready.js.map